<div class="points-summary-bar d-flex flex-row align-items-center justify-content-between w-100">
  <!-- Back Button -->
  <div class="back-btn text-danger cursor-pointer d-flex align-items-center d-lg-none" [routerLink]="[backButtonLink]">
    <div class="back-button" [routerLink]="backButtonLink">
      <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
    </div>
  </div>
  <!-- Points Bar -->
  <div class="justify-content-center h-100">
    <fgb-points-summary></fgb-points-summary>
  </div>
</div>
